import { useEffect, useState } from "react";
import ContactForm from "./ContactForm";
import ContactFormCompleted from "./ContactFormCompleted";
import Loader from "../../components/loader/Loader";
import { sendContactFormData } from "./ContactFormApi";
import ContactFormError from "./ContactFormError";

type ContactFormStep = 'FORM' | 'COMPLETED' | 'ERROR';
export type Intention = 'VOLLEYBALL' | 'LARGE_GROUP_PUBLIC' | 'INDIVIDUAL';

export interface ContactFormHandlerProps { intention: Intention };

function getHeadline(intention: Intention): string {
    switch (intention) {
        case "VOLLEYBALL": return 'Volleyball';
        case "LARGE_GROUP_PUBLIC": return 'Gruppenmiete im öffentlichen Betrieb';
        case "INDIVIDUAL": return 'Individuelle Anfrage';
    }
}

export interface ContactFormData {
    firstName: string;
    lastName: string;
    email: string;
    attendees: number;
    start: Date;
    end: Date;
    text: string;
}

export default function ContactFormHandler(props: ContactFormHandlerProps) {

    const [step, setStep] = useState<ContactFormStep>('FORM');
    const [isLoading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [step]);

    function handleFormSubmit(data: ContactFormData) {
        sendContactFormData(data, props.intention)
            .then(result => {
                if (result) {
                    setStep('COMPLETED');
                } else {
                    setStep('ERROR');
                }
                setLoading(false);
            })
        setLoading(true);
    }

    return <>
        <Loader active={isLoading}>
            {step === 'FORM' && <ContactForm intention={props.intention} headline={getHeadline(props.intention)} onSubmit={handleFormSubmit} />}
            {step === 'COMPLETED' && <ContactFormCompleted />}
            {step === 'ERROR' && <ContactFormError />}
        </Loader>
    </>
}